module.exports = __webpack_public_path__ + "static/media/cool_field3.2ba9abca.png";